import script from "./TabelasCodigo.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelasCodigo.vue?vue&type=script&setup=true&lang=js"

import "./TabelasCodigo.vue?vue&type=style&index=0&id=c4b5fef8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b5fef8"]])

export default __exports__